import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

// Icons
import FraudProtectionIcon from '../../../common/components/icons/FraudProtectionIcon';
import SafeTicketIcon from '../../../common/components/icons/SafeTicketIcon';
import HomeProtectionIcon from '../../../common/components/icons/HomeProtectionIcon';

import './HiwGuarentee.scss';

const HiwGuarentee = () => (
  <div id="guarantee" className="hiw-guarentee">
    <img
      alt={trans('how_it_works.guarantee.block1.title')}
      className="hiw-guarentee__title"
      src={getResourcePath('/images/how-it-works/sah-guarantee-title.png')}
    />

    <span className="hiw-guarentee__subtitle">
      {trans('how_it_works.guarantee.subtitle')}
    </span>

    <div className="hiw-guarentee__block-wrapper">
      <div className="hiw-guarentee__block">
        <FraudProtectionIcon className="hiw-guarentee__block-icon" />
        <div className="hiw-guarentee__block-container">
          <h5 className="hiw-guarentee__block-title">
            {trans('how_it_works.guarantee.block1.title')}
          </h5>
          <p className="hiw-guarentee__text">
            {trans('how_it_works.guarantee.block1.text')}
          </p>
        </div>
      </div>

      <div className="hiw-guarentee__block">
        <SafeTicketIcon className="hiw-guarentee__block-icon" />
        <div className="hiw-guarentee__block-container">
          <h5 className="hiw-guarentee__block-title">
            {trans('how_it_works.guarantee.block2.title')}
          </h5>
          <p className="hiw-guarentee__text">
            {trans('how_it_works.guarantee.block2.text')}
          </p>
        </div>
      </div>

      <div className="hiw-guarentee__block">
        <HomeProtectionIcon className="hiw-guarentee__block-icon" />
        <div className="hiw-guarentee__block-container">
          <h5 className="hiw-guarentee__block-title">
            {trans('how_it_works.guarantee.block3.title')}
          </h5>
          <p className="hiw-guarentee__text">
            {trans('how_it_works.guarantee.block3.text')}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default HiwGuarentee;
